var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('div',[_c('h2',[_vm._v("Formulário: "+_vm._s(_vm.form.formName))])]),_c('checklist-fill',{ref:"teste",attrs:{"checklist":_vm.form,"token":_vm.$store.getters.token},on:{"finishFilling":_vm.getChecklistNew}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }